import styled, { css } from 'styled-components';
import { NavLink as RouterNavLink, Link as RouterLink } from 'react-router-dom';

export const defaultLinkStyles = css`
  margin: 0;
  padding: 0;
  font-size: 100%;
  vertical-align: baseline;
  color: ${({ theme: { colors } }) => colors.brand.secondary.default};
  background: transparent;
  text-decoration: none;
  cursor: pointer;

  :hover {
    background: none;
    color: ${({ theme: { colors } }) => colors.gray.dark};
  }
`;

export const StyledLink = styled.a`
  ${defaultLinkStyles}
`;

export const NavLink = styled(RouterNavLink)`
  ${defaultLinkStyles}
`;

export const Link = styled(RouterLink)`
  ${defaultLinkStyles}
`;
